import { colors } from '../../colors';
var form = {
  bgColor: colors.equineSnow,
  labelColor: colors.equineSnow,
  errorColor: colors.equineSnow,
  borderColor: colors.equineSnow,
  linkColor: colors.equineSnow,
  documentFormBgColor: colors.equineSnow
};
export default form;